import * as tslib_1 from "tslib";
import { Directive, ViewContainerRef, ComponentFactoryResolver, Input } from "@angular/core";
import { FilterHostDirective } from "../filter-host.directive";
import { isNullOrEmptyString, isPresent } from "../../utils";
import { filterMenuComponentFactory } from "./filter-menu-component.factory";
import { StringFilterMenuComponent } from "./string-filter-menu.component";
/**
 * @hidden
 */
var FilterMenuHostDirective = /** @class */ (function (_super) {
    tslib_1.__extends(FilterMenuHostDirective, _super);
    function FilterMenuHostDirective(host, resolver) {
        return _super.call(this, host, resolver) || this;
    }
    FilterMenuHostDirective.prototype.componentType = function () {
        if (isPresent(this.column) && !isNullOrEmptyString(this.column.filter)) {
            return filterMenuComponentFactory(this.column.filter);
        }
        return StringFilterMenuComponent;
    };
    FilterMenuHostDirective.prototype.initComponent = function (ctx) {
        _super.prototype.initComponent.call(this, ctx);
        this.component.instance.filterService = this.filterService;
    };
    FilterMenuHostDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[kendoFilterMenuHost]'
                },] },
    ];
    /** @nocollapse */
    FilterMenuHostDirective.ctorParameters = function () { return [
        { type: ViewContainerRef, },
        { type: ComponentFactoryResolver, },
    ]; };
    FilterMenuHostDirective.propDecorators = {
        'filterService': [{ type: Input },],
    };
    return FilterMenuHostDirective;
}(FilterHostDirective));
export { FilterMenuHostDirective };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-grid/dist/es/filtering/menu/filter-menu-host.directive.js
// module id = ../../../../@progress/kendo-angular-grid/dist/es/filtering/menu/filter-menu-host.directive.js
// module chunks = vendor